import { render, staticRenderFns } from "./BookingApprovalPatient.vue?vue&type=template&id=d75793b2"
import script from "./BookingApprovalPatient.vue?vue&type=script&lang=js"
export * from "./BookingApprovalPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports